import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { authApi } from '../auth.api';
import { useAuthStore } from '../auth.store';

/**
 * Cierra la sesión.
 *
 * El backend es stateless: basta con descartar los tokens localmente. La llamada
 * a la API se hace "best effort" para dejar registro en el servidor.
 */
export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const clearSession = useAuthStore((state) => state.clearSession);

  return useCallback(async () => {
    try {
      await authApi.logout();
    } catch {
      // La sesión local se limpia igual: el usuario no debe quedar atrapado.
    }

    clearSession();
    queryClient.clear();
    navigate('/login', { replace: true });
  }, [clearSession, navigate, queryClient]);
}
